import React from 'react';
import Heading from 'src/elements/typography/heading';
import Paragraph from 'src/elements/typography/paragraph';

import { IdealMemberFormGridContainer, TextBlock, InputBlock } from './IdealMemberFormGrid.styles';
import FadeInAnimationWrapper from 'src/elements/animation/fade-in/FadeInAnimationWrapper';
import IdealMembersInputSmall from 'src/molecules/Standard/NameGenerator/IdealMembersInput/IdealMembersInputSmall';

interface IdealMemberFormGridProps {
  title?: string;
  subtitle?: string;
  helperText?: string;
  statsigEvent?: string | boolean;
}

const IdealMemberFormGrid = ({
  title = 'Start your free trial',
  subtitle = 'Who do you want to bring together?',
  helperText = 'Examples: coaching clients, meditation novices, vegan chefs, dog lovers, aspiring entrepreneurs, etc.',
  statsigEvent = 'homepage_generator_submit',
}: IdealMemberFormGridProps): JSX.Element => {
  return (
    <IdealMemberFormGridContainer>
      <FadeInAnimationWrapper>
        <TextBlock>
          <Heading
            text={title}
            standardSize='2.5'
            align='center'
          />
          <Paragraph
            text={subtitle}
            standardSize='1.5'
            align='center'
            className='cohost-ideal-member-form-description'
          />
        </TextBlock>
      </FadeInAnimationWrapper>
      <InputBlock>
        <IdealMembersInputSmall
          generationMode='generator'
          mobileText='Go'
          statsigEvent={typeof statsigEvent === 'string' ? statsigEvent : undefined}
        />
        <FadeInAnimationWrapper>
          <Paragraph
            text={helperText}
            className='cohost-ideal-member-form-examples'
            standardSize='1.125'
            align='center'
          />
        </FadeInAnimationWrapper>
      </InputBlock>
    </IdealMemberFormGridContainer>
  );
};

export default IdealMemberFormGrid;
